<div class="container">
  <mat-list>
    <div mat-subheader>Printers</div>
    @for (printer of printers; track printer) {
      <mat-list-item>
        <mat-icon>print</mat-icon>
        <div>{{printer.name}}</div>
        <div> {{printer.deviceURI}}</div>
      </mat-list-item>
    }
  </mat-list>
</div>
